import { useEffect, useState } from 'react';
import { FilterSelectorStorageKey } from '../../../enums/FilterSelectorStorageKey';
import { Checkbox, CheckboxProps, Collapse } from 'antd';
import { StorageKey } from '../../../enums/StorageKey';
import './FilterSelector.less';

export interface IFilterSelectorProps {
    storageKey: FilterSelectorStorageKey;
    columns: { key: string; title: string }[];
    disabled: boolean;
    onChange: (selectedOptions: string[]) => void;
}

export const FilterSelector = (props: IFilterSelectorProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedOptions, setSelectedOptions] = useState<string[]>(() => {
        const savedStorage = localStorage.getItem(StorageKey.FilterSelector);
        if (savedStorage) {
            const parsedStorage = JSON.parse(savedStorage);
            if (parsedStorage[props.storageKey]) {
                return parsedStorage[props.storageKey];
            }
        }
        return [...props.columns].map((c) => c.key);
    });

    const onChange: CheckboxProps['onChange'] = (e) => {
        const targetName = e.target.name;

        if (targetName) {
            let newSelectedOptions = [...selectedOptions];
            newSelectedOptions = e.target.checked
                ? [...newSelectedOptions, targetName]
                : newSelectedOptions.filter((o) => o !== targetName);

            const savedStorage = localStorage.getItem(StorageKey.FilterSelector);
            let newStorageData;

            if (!savedStorage) {
                newStorageData = { [props.storageKey]: newSelectedOptions };
            } else {
                newStorageData = JSON.parse(savedStorage);
                newStorageData[props.storageKey] = newSelectedOptions;
            }

            setSelectedOptions(newSelectedOptions);
            localStorage.setItem(StorageKey.FilterSelector, JSON.stringify(newStorageData));
            props.onChange(newSelectedOptions);
        }
    };

    useEffect(() => {
        if (props.columns.length > 0) {
            const savedStorage = localStorage.getItem(StorageKey.FilterSelector);
            const activeKeys = [...props.columns].map((c) => c.key);
            let value;

            //no storage available for any of the filters or not for the current filter
            if (!savedStorage) {
                value = { [props.storageKey]: [...activeKeys] };
            } else {
                const parsedStorage = JSON.parse(savedStorage);
                if (!parsedStorage[props.storageKey]) {
                    value = parsedStorage;
                    value[props.storageKey] = activeKeys;
                }
            }

            if (value) {
                setSelectedOptions([...activeKeys]);
                localStorage.setItem(StorageKey.FilterSelector, JSON.stringify(value));
            }
        }
    }, [props.columns]);

    useEffect(() => {
        props.onChange(selectedOptions);
    }, [selectedOptions]);

    return (
        <div className="filter-selector">
            <Collapse
                activeKey={isOpen ? [0] : undefined}
                size="small"
                accordion={true}
                onChange={() => setIsOpen(!isOpen)}
                items={[
                    {
                        key: '0',
                        label: <>{`${isOpen ? 'HIDE' : 'SHOW'} COLUMNS`}</>,
                        collapsible: 'header',
                        forceRender: true,
                        children: (
                            <div className="options">
                                {props.columns.map((column) => (
                                    <div className="option" key={column.key}>
                                        <Checkbox
                                            disabled={
                                                (selectedOptions.length === 1 &&
                                                    selectedOptions.filter((o) => o === column.key).length > 0) ||
                                                props.disabled
                                            }
                                            name={column.key}
                                            onChange={onChange}
                                            checked={selectedOptions.filter((o) => o === column.key).length > 0}
                                        >
                                            {column.title}
                                        </Checkbox>
                                    </div>
                                ))}
                            </div>
                        ),
                    },
                ]}
            />
        </div>
    );
};
